import { BusinessGetResponseType } from "@sellar-io/api-v2/types";
import { useSellarCurrentBusiness } from "./useSellarCurrentBusiness.shared";

export const useSellarSupplier = (): NonNullable<
  BusinessGetResponseType["Supplier"]
> => {
  const { business } = useSellarCurrentBusiness();
  if (!business?.Supplier) throw new Error("Cannot find supplier");

  return business.Supplier;
};
